// extracted by mini-css-extract-plugin
module.exports = {"container":"_3433qKBr1-bwFRcVn-1lUe","icon":"_1DbsiUtGZMV_1WTVJy5Q2J"};